const required = (message = 'Required') =>
    value => value || value === 0 ? undefined : message;
const isBool = (message = 'Required') =>
    value => typeof value === 'boolean' ? undefined : message;
const maxLength = (max, message = 'Too short') =>
    value => value && value.length > max ? message : undefined;
const number = (message = 'Must be a number') =>
    value => value && isNaN(Number(value)) ? message : undefined;
const minValue = (min, message = 'Too small') =>
    value => value && value < min ? message : undefined;
const maxValue = (max, message = 'Too much') =>
    value => value && value > max ? message : undefined;
const notZero = (message = `Can't put zero`) =>
    value => value === 0 ? message : undefined

export { required, isBool, maxLength, number, minValue, maxValue, notZero }


// WEBPACK FOOTER //
// ./src/services/validate.js